import React, {Component} from "react";
import heroLogo from "../../images/icons/heroLogo.png";
import styled from "styled-components";
import { FlexibleSpacer } from "../Spacer";
import { Link } from 'react-router-dom';

const Container = styled.div`
  position: sticky; top: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 92px;
  padding-right: 40px;
  padding-left: 40px;
  background-color: #faf8f7;

  @media only screen and (max-width: 896px) {
    padding-left: 0;
    padding-right: 0;
    height: 72px;
  }
`;

const LinkContainer = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 92px;
`;

const Logo = styled.div<{ icon: string }>`
  width: 28px;
  height: 28px;
  background: url(${props => props.icon}) no-repeat center;
  background-size: 28px;
  margin-top: 0;
  margin-right: 8px;
`;

const Type = styled.span`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 600;
  line-height: 24px;
  color: #A39C99;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 600;
    line-height: 24px;
  }
`;

const Logotype = () => (
  <LinkContainer to="/">
    <Logo icon={heroLogo}/>
    <Type>
      Zebra
    </Type>
  </LinkContainer>
);

const Subtitle = styled.span`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 500;
  line-height: 24px;
  color: #A39C99;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 500;
    line-height: 24px;
  }
`;

class NavigationHeader extends Component {
  //  As the landing pages is static, there is no need to re-render.
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Container>
        <Logotype/>
        <FlexibleSpacer/>
        {/* {<Subtitle>
          Coming August
        </Subtitle>} */}
      </Container>
    );
  }
}

export default NavigationHeader;